import { addMinutes } from '@src/utils/dateUtils';

interface CacheItem<T> {
  expiryDate: Date;
  data: T[];
}

const cacheEntryTtlMins = 10;
const infoCache: { [key: string]: CacheItem<any> } = {};
const fetchPromises: { [key: string]: Promise<any> | null } = {};

export const getCachedData = <T>(
  cacheKey: string
): CacheItem<T> | undefined => {
  const cachedItem = infoCache[cacheKey];
  if (
    cachedItem &&
    cachedItem.expiryDate &&
    new Date(cachedItem.expiryDate).getTime() > new Date().getTime()
  ) {
    return cachedItem;
  }
  return undefined;
};

export const setCachedData = <T>(
  cacheKey: string,
  data: T[],
  ttlMinutes: number = cacheEntryTtlMins
): void => {
  infoCache[cacheKey] = {
    expiryDate: addMinutes(new Date(), ttlMinutes)!,
    data,
  };
  fetchPromises[cacheKey] = null;
};

export const getFetchPromise = (cacheKey: string): Promise<any> | null => {
  return fetchPromises[cacheKey] || null;
};

export const setFetchPromise = (
  cacheKey: string,
  promise: Promise<any>
): void => {
  fetchPromises[cacheKey] = promise;
};
